/**
 * Grille collection/recherche : 24 fiches par page, sans recharger la carte.
 * Marqueurs : ?view=markers (paginate 250, payload léger), toutes les pages
 * de ce flux, indépendant de ?page= de la grille.
 */
(function () {
  'use strict';

  var MARKER_PAGE_CAP = 12;
  var markerGen = 0;
  var gridGen = 0;
  var pendingTimer = null;

  function collectionHandle() {
    var m = (window.location.pathname || '').match(/\/collections\/([^/?#]+)/i);
    return m ? String(m[1] || '').toLowerCase() : '';
  }

  function isNamedCollection() {
    if (!document.body || !document.body.classList.contains('template-collection')) return false;
    var handle = collectionHandle();
    return !!(handle && handle !== 'search' && handle !== 'tous-les-hebergements');
  }

  function shouldFetchLiquidMarkers() {
    if (!document.getElementById('collection-map-locations-json')) return false;
    if (!document.body) return false;
    var isCollection = document.body.classList.contains('template-collection');
    var isSearch = document.body.classList.contains('template-search');
    if (!isCollection && !isSearch) return false;
    var params = new URLSearchParams(window.location.search);
    if (params.get('start') && params.get('end')) return false;
    var handle = collectionHandle();
    if (isCollection && (handle === 'search' || handle === 'tous-les-hebergements')) return false;
    return true;
  }

  function armPendingTimeout() {
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      if (!window.__lovenMarkersFetchPending) return;
      window.__lovenMarkersFetchPending = false;
      if (typeof window.syncCollectionMapMarkersToProductGrid === 'function') {
        window.syncCollectionMapMarkersToProductGrid();
      }
    }, 8000);
  }

  function paramsExceptPage(search) {
    var params = new URLSearchParams(search || '');
    params.delete('page');
    params.delete('section_id');
    var entries = [];
    params.forEach(function (value, key) {
      entries.push(key + '=' + value);
    });
    entries.sort();
    return entries.join('&');
  }

  window.__lovenRememberGridQuery = function () {
    window.__lovenGridQueryKey = paramsExceptPage(window.location.search);
  };

  function readPage() {
    var n = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad;
    var dLon = (lon2 - lon1) * toRad;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function readDest() {
    try {
      var params = new URLSearchParams(window.location.search);
      var lat = parseFloat(params.get('dest_lat'));
      var lon = parseFloat(params.get('dest_lon'));
      if (!params.get('dest_lat') || !params.get('dest_lon') || isNaN(lat) || isNaN(lon)) return null;
      var fallback =
        typeof window.__lovenReadDestRadiusFallbackKm === 'function'
          ? window.__lovenReadDestRadiusFallbackKm()
          : 50;
      var radius = parseFloat(params.get('dest_radius_km') || String(fallback));
      if (isNaN(radius) || radius <= 0) radius = fallback;
      if (radius === 80) radius = 50;
      radius = Math.min(500, Math.max(5, radius));
      return { lat: lat, lon: lon, radiusKm: radius };
    } catch (e) {
      return null;
    }
  }

  function filterMarkersByDest(locations) {
    if (!isNamedCollection()) return locations;
    var dest = readDest();
    if (!dest || !locations || !locations.length) return locations;
    var inside = locations.filter(function (loc) {
      var lat = Number(loc && loc.lat);
      var lon = Number(loc && loc.lon);
      if (!isFinite(lat) || !isFinite(lon)) return false;
      return haversineKm(dest.lat, dest.lon, lat, lon) <= dest.radiusKm;
    });
    if (!inside.length) return locations;
    window.__lovenGeoMarkerCount = inside.length;
    return inside;
  }

  function markerUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.set('view', 'markers');
    if (page > 1) url.searchParams.set('page', String(page));
    return url.pathname + '?' + url.searchParams.toString();
  }

  function fetchMarkerPage(page) {
    return fetch(markerUrl(page), { credentials: 'same-origin' }).then(function (response) {
      return response.text().then(function (text) {
        if (!response.ok) throw new Error('markers ' + response.status);
        return JSON.parse(text);
      });
    });
  }

  function fetchAllMarkers(gen) {
    var all = [];
    function next(page) {
      if (gen !== markerGen) return Promise.resolve(all);
      return fetchMarkerPage(page).then(function (data) {
        if (gen !== markerGen) return all;
        var locations = data && Array.isArray(data.locations) ? data.locations : [];
        all = all.concat(locations);
        var pages = data && data.pages ? Number(data.pages) : 1;
        if (page < pages && page < MARKER_PAGE_CAP) return next(page + 1);
        return all;
      });
    }
    return next(1);
  }

  function applyMarkers(locations) {
    locations = filterMarkersByDest(locations || []);
    if (!locations.length) {
      window.__lovenMarkersFetchPending = false;
      window.__lovenCollectionMarkersComplete = false;
      if (typeof window.syncCollectionMapMarkersToProductGrid === 'function') {
        window.syncCollectionMapMarkersToProductGrid();
      }
      return;
    }
    window.__lovenCollectionMarkersComplete = true;
    window.__lovenMarkersFetchPending = false;
    if (typeof window.LovenCollectionMapApplyLocationsJson === 'function') {
      window.LovenCollectionMapApplyLocationsJson({ locations: locations });
    }
    if (typeof window.LovenUpdateCollectionResultsCount === 'function') {
      window.LovenUpdateCollectionResultsCount();
    }
  }

  function scheduleMarkerFetch() {
    var gen = ++markerGen;
    window.__lovenCollectionMarkersComplete = false;
    window.__lovenGeoMarkerCount = undefined;
    if (!document.getElementById('collection-map-locations-json')) return;
    window.__lovenMarkersFetchPending = true;
    armPendingTimeout();
    if (!shouldFetchLiquidMarkers()) return;
    fetchAllMarkers(gen)
      .then(function (locations) {
        if (gen !== markerGen) return;
        applyMarkers(locations);
      })
      .catch(function () {
        if (gen !== markerGen) return;
        window.__lovenMarkersFetchPending = false;
        window.__lovenCollectionMarkersComplete = false;
        if (typeof window.syncCollectionMapMarkersToProductGrid === 'function') {
          window.syncCollectionMapMarkersToProductGrid();
        }
      });
  }

  function scrollGridToTop() {
    var mobile = false;
    try {
      mobile = window.matchMedia('(max-width: 768px)').matches;
    } catch (e) {}
    var sheet = document.getElementById('loven-rooms-sheet-body');
    if (mobile && sheet) {
      sheet.scrollTop = 0;
      return;
    }
    var grid = document.querySelector(
      '.loven-static-collection-grid, #loven-dynamic-availability .collection-grid__wrapper'
    );
    if (!grid) return;
    var header = document.querySelector('#SiteHeader, .site-header');
    var offset = header ? header.offsetHeight + 12 : 12;
    var top = grid.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  window.LovenScrollCollectionGridToTop = scrollGridToTop;

  function focusUpdatedGrid(scope) {
    var root = scope || document;
    var current = root.querySelector('.loven-collection-pagination .page.current');
    var target = current;
    if (!target) target = root.querySelector('.product-grid');
    if (!target) return;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      target.focus();
    }
  }

  function announcePage() {
    var live = document.getElementById('loven-grid-page-status');
    if (!live) {
      live = document.createElement('div');
      live.id = 'loven-grid-page-status';
      live.setAttribute('aria-live', 'polite');
      live.style.cssText =
        'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
      document.body.appendChild(live);
    }
    live.textContent = 'Page ' + readPage();
  }

  var CONTINUOUS_CAP = 250;
  var appendGen = 0;

  function staticGrid() {
    return document.querySelector('.loven-static-collection-grid .product-grid');
  }

  function gridCardCount() {
    var grid = staticGrid();
    return grid ? grid.querySelectorAll('.grid-item.grid-product').length : 0;
  }

  function nextPageLink() {
    return document.querySelector('#CollectionAjaxResult .loven-collection-pagination a[rel="next"]');
  }

  function markPagerContinuous() {
    var pager = document.querySelector('#CollectionAjaxResult .loven-collection-pagination');
    if (pager) pager.classList.add('is-continuous');
  }

  function revealPager() {
    var pager = document.querySelector('#CollectionAjaxResult .loven-collection-pagination');
    if (pager) pager.classList.remove('is-continuous');
  }

  /**
   * Résout `done: true` quand il n'y a plus rien à ajouter. Ne relance jamais
   * une étape sans progrès : une boucle qui se rappelle sans attendre gèle la page.
   */
  function appendContinuousPage(gen, seen) {
    if (gen !== appendGen) return Promise.resolve({ done: true });
    if (readPage() !== 1 || window.__lovenDynamicAvailabilityMode) return Promise.resolve({ done: true });
    if (gridCardCount() >= CONTINUOUS_CAP) return Promise.resolve({ done: true });
    var link = nextPageLink();
    var root = document.getElementById('CollectionAjaxResult');
    var sectionId = root && root.getAttribute('data-section-id');
    if (!link || !sectionId) return Promise.resolve({ done: true });
    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    var key = url.searchParams.get('page') || url.toString();
    if (seen[key]) return Promise.resolve({ done: true });
    seen[key] = true;
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('section');
        return response.text();
      })
      .then(function (html) {
        if (gen !== appendGen) return { done: true };
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incomingGrid = doc.querySelector('.loven-static-collection-grid .product-grid');
        var liveGrid = staticGrid();
        if (!incomingGrid || !liveGrid) throw new Error('grid');
        var existing = {};
        liveGrid.querySelectorAll('[data-product-handle]').forEach(function (el) {
          var handle = el.getAttribute('data-product-handle');
          if (handle) existing[handle] = true;
        });
        var cards = incomingGrid.querySelectorAll('.grid-item.grid-product');
        var added = 0;
        for (var i = 0; i < cards.length; i++) {
          if (gridCardCount() >= CONTINUOUS_CAP) break;
          var handle = cards[i].getAttribute('data-product-handle');
          if (handle && existing[handle]) continue;
          if (handle) existing[handle] = true;
          liveGrid.appendChild(document.importNode(cards[i], true));
          added++;
        }
        var incomingPager = doc.querySelector('.loven-collection-pagination');
        var livePager = document.querySelector('#CollectionAjaxResult .loven-collection-pagination');
        if (livePager) {
          if (incomingPager) {
            var pager = document.importNode(incomingPager, true);
            pager.classList.add('is-continuous');
            livePager.replaceWith(pager);
          } else {
            livePager.remove();
          }
        }
        if (added && typeof theme !== 'undefined' && typeof theme.reinitProductGridItem === 'function') {
          theme.reinitProductGridItem();
        }
        return { done: !added && !nextPageLink() };
      });
  }

  function runContinuous() {
    if (readPage() !== 1 || window.__lovenDynamicAvailabilityMode) return;
    /* Recherche avec dates / tous-les-hébergements : la grille vient de l'API, pas du Liquid. */
    if (!shouldFetchLiquidMarkers()) return;
    if (!nextPageLink()) return;
    var gen = ++appendGen;
    var seen = {};
    var steps = 0;
    markPagerContinuous();
    function finish() {
      if (typeof window.LovenPaintSponsoredBadges === 'function') window.LovenPaintSponsoredBadges();
    }
    function step() {
      if (gen !== appendGen) return;
      steps++;
      if (steps > MARKER_PAGE_CAP || gridCardCount() >= CONTINUOUS_CAP || !nextPageLink()) {
        finish();
        return;
      }
      appendContinuousPage(gen, seen)
        .then(function (result) {
          if (gen !== appendGen) return;
          if (result && result.done) {
            finish();
            return;
          }
          window.setTimeout(step, 0);
        })
        .catch(function () {
          if (gen !== appendGen) return;
          revealPager();
        });
    }
    step();
  }

  function loadGridPage(href, pushHistory) {
    var root = document.getElementById('CollectionAjaxResult');
    var sectionId = root && root.getAttribute('data-section-id');
    if (!root || !sectionId) {
      window.location.href = href;
      return;
    }
    var gen = ++gridGen;
    var current = document.querySelector('.loven-static-collection-grid');
    if (current) {
      current.classList.add('is-page-loading');
      current.setAttribute('aria-busy', 'true');
    }
    var url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('section');
        return response.text();
      })
      .then(function (html) {
        if (gen !== gridGen) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('.loven-static-collection-grid');
        var live = document.querySelector('.loven-static-collection-grid');
        if (!next || !live) throw new Error('grid');
        live.replaceWith(next);
        if (pushHistory) {
          var clean = new URL(href, window.location.origin);
          clean.searchParams.delete('section_id');
          history.pushState({}, '', clean.pathname + clean.search + clean.hash);
        }
        window.__lovenRememberGridQuery();
        window.__lovenPreserveMapCamera = true;
        if (typeof window.LovenCollectionDestFilterRun === 'function') {
          window.LovenCollectionDestFilterRun();
        }
        window.__lovenPreserveMapCamera = false;
        if (typeof theme !== 'undefined' && typeof theme.reinitProductGridItem === 'function') {
          theme.reinitProductGridItem();
        }
        if (typeof window.LovenPaintSponsoredBadges === 'function') window.LovenPaintSponsoredBadges();
        if (typeof window.LovenBoostSponsoredGrid === 'function') {
          window.LovenBoostSponsoredGrid({ force: true });
        }
        scrollGridToTop();
        announcePage();
        focusUpdatedGrid(document.querySelector('.loven-static-collection-grid') || document);
      })
      .catch(function () {
        if (gen !== gridGen) return;
        window.location.href = href;
      });
  }

  window.__lovenHandleCollectionGridPopstate = function () {
    if (paramsExceptPage(window.location.search) !== window.__lovenGridQueryKey) return false;
    if (window.__lovenDynamicAvailabilityMode && typeof window.LovenRenderDynamicGridPage === 'function') {
      window.LovenRenderDynamicGridPage(readPage());
      scrollGridToTop();
      announcePage();
      return true;
    }
    loadGridPage(window.location.href, false);
    return true;
  };

  document.addEventListener(
    'collection:reloaded',
    function () {
      appendGen += 1;
      window.__lovenRememberGridQuery();
      scheduleMarkerFetch();
      window.setTimeout(runContinuous, 200);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var link = event.target.closest('#CollectionAjaxResult .loven-collection-pagination a[href]');
    if (!link) return;
    if (link.hasAttribute('data-loven-dyn-page')) return;
    if (window.__lovenDynamicAvailabilityMode) return;
    if (link.closest('.is-continuous')) {
      event.preventDefault();
      return;
    }
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    if (event.button != null && event.button !== 0) return;
    event.preventDefault();
    loadGridPage(link.href, true);
  });

  function boot() {
    window.__lovenRememberGridQuery();
    if (!document.getElementById('collection-map-locations-json')) return;
    var start = function () {
      scheduleMarkerFetch();
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(start, { timeout: 1500 });
    } else {
      window.setTimeout(start, 400);
    }
  }

  function bootAfterFirstPaint() {
    if (document.readyState === 'complete') {
      boot();
      return;
    }
    window.addEventListener('load', boot, { once: true });
  }

  function bootCatalog() {
    window.__lovenRememberGridQuery();
    bootAfterFirstPaint();
    window.setTimeout(runContinuous, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCatalog);
  } else {
    bootCatalog();
  }
})();
